<template>
  <!-- -->
  <div class="system-message-detail">
    <list-page>
      <list-table class="data-detail" background-color="#FFF">
        <form-items :data="dataDetail" :columns="2" ref="form">
          <form-item label="公告标题" :show-block="true" error-message="请输入公告标题" name="messageTitle" :required="true">
            <el-input v-model="dataDetail.messageTitle" placeholder="请输入公告标题"/>
          </form-item>
          <form-item label="公告类型">
            <el-select v-model="dataDetail.messageType" placeholder="请选择">
              <el-option label="通知公告" value="PROCLAMATION"/>
            </el-select>
          </form-item>
          <form-item label="重要级别">
            <el-select v-model="dataDetail.messageLevel" placeholder="请选择">
              <el-option label="普通" :value="1"/>
              <el-option label="重要" :value="2"/>
              <el-option label="紧急" :value="3"/>
            </el-select>
          </form-item>
          <form-item label="有效时间">
            <yq-date-range v-model:start-time="dataDetail.validStart" v-model:end-time="dataDetail.validEnd" :show-short-cut="false"/>
          </form-item>
          <form-item label="选择部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" placeholder="请选择所属部门"/>
            <template #append>
              <el-tooltip content="具有部门权限的人才能看到这个公告">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="提醒人员">
            <el-select v-model="dataDetail.userCategoryType" @change="changeUserCategoryType" placeholder="请选择" clearable>
              <el-option label="不提醒" :value="0"/>
              <el-option label="全部" :value="1"/>
              <el-option label="指定人员" :value="2"/>
              <el-option label="指定角色" :value="3"/>
              <el-option label="指定部门" :value="4"/>
            </el-select>
            <template #append>
              <el-tooltip content="这些人会收到公告的提醒，如果这些人没有部门权限，则相应的增加查询数据的权限">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="指定人员" v-if="dataDetail.userCategoryType">
            <employee-business-type-select v-model="dataDetail.userIds" :business-type="dataDetail.userCategoryType"/>
          </form-item>
          <form-item label="摘要" :show-block="true">
            <el-input v-model="dataDetail.summary" placeholder="请输入摘要内容" type="textarea" :rows="3"/>
            <template #append>
              <el-tooltip content="摘要用于简述内容，在消息提示时进行显示，如果不设置摘要，将使用公告内容进行提示">
                <yq-icon name="element-ui_info" style="color: var(--yq-font-color-desc)"/>
              </el-tooltip>
            </template>
          </form-item>
          <form-item label="公告内容" :show-block="true" name="content" error-message="请输入公告内容" :required="true">
            <rich-text v-model="dataDetail.content"/>
          </form-item>
        </form-items>
      </list-table>
      <form-page :show-page="false">
        <page-button has-perm="sys:message:saveDraft" v-if="dataDetail.messageStatus === 0" el-type="success" type="write" @click="saveDraft">保存草稿</page-button>
        <page-button has-perm="sys:message:savePublish" :disabled="dataDetail.messageStatus === 1" el-type="primary" type="write" @click="saveSubmit">发布公告</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import PageButton from "@/components/h5/button/PageButton";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
import RichText from "@/components/h5/richText/RichText.vue";
import YqIcon from "@/components/YqIcon.vue";
import EmployeeBusinessTypeSelect from "@/components/h5/data/EmployeeBusinessTypeSelect.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import commonApi from "@/api/commonApi";
import systemMessageApi from "@/api/normal/sys/systemMessageApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqIcon, PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, YqDateRange, RichText, EmployeeBusinessTypeSelect, DepartSelect
  },
  data() {
    return {
      dataDetail: {
        messageTitle: "",
        messageType: "PROCLAMATION",
        messageLevel: 1,
        userCategoryType: 0,
        validStart: "",
        validEnd: "",
        userIds: "",
        departCode: "",
        messageStatus: 0,
        userType: 1, // 1是职员消息，2是客户消息(小程序消息)
      },
      departTree: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (this.route.query.id) {
      systemMessageApi.findById(this.route.query.id).then(data => {
        this.dataDetail = data;
      })
    }
    commonApi.queryDepartList().then(list => {
      this.departTree = list
    });
  },
  methods: {
    init() {

    },
    // 当人员类型发生变更时，将指定人员清空
    changeUserCategoryType() {
      this.dataDetail.userIds = "";
    },
    saveDraft() {
      if (!this.$refs.form.validCheck()) {
        return;
      }
      systemMessageApi.saveDraft(this.dataDetail).then(res => {
        this.dataDetail = res;
      })
    },
    saveSubmit() {
      if (!this.$refs.form.validCheck()) {
        return;
      }
      systemMessageApi.savePublish(this.dataDetail).then(res => {
        this.dataDetail = res;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.system-message-detail{
  .data-detail{
    padding: 10px;
  }
}
</style>